import React, { useState, useEffect, useRef } from 'react';

const NewsTicker = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [tickerOpacity, setTickerOpacity] = useState(1);
  const mobileRef = useRef(null);

  // Fade da tarja + letras ao rolar para baixo (some) e reaparece perto do topo
  useEffect(() => {
    const fadeDistance = 160;
    const handleScroll = () => {
      const y = window.scrollY || window.pageYOffset || 0;
      const op = Math.max(0, Math.min(1, 1 - y / fadeDistance));
      setTickerOpacity(op);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const newsTexts = [
    "FÓRMULA AMERICANA CAPAZ DE INIBIR O APETITE E PROMOVER O EMAGRECIMENTO",
    "PERCA ATÉ 12CM DE CINTURA EM POUCOS DIAS",
    "EMAGREÇA JÁ NA PRIMEIRA SEMANA SEM EFEITOS COLATERAIS 100% NATURAL"
  ];

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Animação automática para mobile
  useEffect(() => {
    if (!isMobile || !mobileRef.current) return;

    let scrollPos = 0;
    const scrollSpeed = 1;
    let animationId;

    const animate = () => {
      scrollPos += scrollSpeed;
      const container = mobileRef.current;
      
      if (container) {
        const maxScroll = container.scrollWidth - container.clientWidth;
        
        if (scrollPos >= maxScroll) {
        scrollPos = 0;
        container.scrollLeft = 0;
      } else {
        container.scrollLeft = scrollPos;
        }
      }
      
      animationId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
  };
  }, [isMobile]);

  // Animação vertical para desktop
  useEffect(() => {
    if (isMobile) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % newsTexts.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [newsTexts.length, isMobile]);

  // MOBILE: Transição automática e infinita horizontal
  if (isMobile) {
  return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '57px',
        background: 'linear-gradient(90deg, #1c4448 0%, #255a5e 50%, #1c4448 100%)',
        borderBottom: '2px solid rgba(195, 152, 87, 0.65)',
        boxShadow: '0 4px 18px rgba(0, 0, 0, 0.18)',
        opacity: tickerOpacity,
        pointerEvents: tickerOpacity < 0.05 ? 'none' : 'auto',
        transition: 'opacity 0.25s ease',
        zIndex: 1000
      }}>
        <div 
          ref={mobileRef}
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            overflowX: 'auto',
            overflowY: 'hidden',
            whiteSpace: 'nowrap',
            padding: '0 20px',
            gap: '20px',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }}
        >
          {/* Textos duplicados para scroll infinito */}
            {newsTexts.map((text, index) => (
            <div key={`mobile-1-${index}`} style={{
              display: 'inline-block',
              color: '#FFFFFF',
              fontWeight: 700,
              fontSize: '1rem',
              whiteSpace: 'nowrap',
              minWidth: '300px',
              padding: '0 20px',
              textAlign: 'center',
              textTransform: 'uppercase',
              textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
              flexShrink: 0
            }}>
                {text}
              </div>
            ))}
            {newsTexts.map((text, index) => (
            <div key={`mobile-2-${index}`} style={{
              display: 'inline-block',
              color: '#FFFFFF',
              fontWeight: 700,
              fontSize: '1rem',
              whiteSpace: 'nowrap',
              minWidth: '300px',
              padding: '0 20px',
              textAlign: 'center',
              textTransform: 'uppercase',
              textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
              flexShrink: 0
            }}>
                {text}
              </div>
            ))}
          {newsTexts.map((text, index) => (
            <div key={`mobile-3-${index}`} style={{
              display: 'inline-block',
              color: '#FFFFFF',
              fontWeight: 700,
              fontSize: '1rem',
              whiteSpace: 'nowrap',
              minWidth: '300px',
              padding: '0 20px',
              textAlign: 'center',
              textTransform: 'uppercase',
              textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
              flexShrink: 0
            }}>
              {text}
            </div>
          ))}
        </div>
      </div>
    );
  }

  // DESKTOP: Animação vertical original
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '50px',
      background: 'linear-gradient(90deg, #1c4448 0%, #255a5e 50%, #1c4448 100%)',
      borderBottom: '2px solid rgba(195, 152, 87, 0.65)',
      boxShadow: '0 4px 18px rgba(0, 0, 0, 0.18)',
      opacity: tickerOpacity,
      pointerEvents: tickerOpacity < 0.05 ? 'none' : 'auto',
      transition: 'opacity 0.25s ease',
      zIndex: 1000,
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{
        position: 'relative',
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {newsTexts.map((text, index) => (
          <div
            key={index}
            style={{
              position: 'absolute',
              color: '#FFFFFF',
              fontWeight: 700,
              fontSize: '1.1rem',
              lineHeight: '1.2',
              padding: '0 80px',
              letterSpacing: '0.5px',
              opacity: index === currentIndex ? 1 : 0,
              transform: index === currentIndex ? 'translateY(0)' : 'translateY(-20px)',
              transition: 'all 0.8s ease',
              whiteSpace: 'nowrap',
              textAlign: 'center',
              width: 'calc(100% + 160px)',
              marginLeft: '-80px',
              marginRight: '-80px',
              textTransform: 'uppercase',
              textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
            }}
          >
            {text}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsTicker;
